#app-root-2026-tdr_report-marimekko-focus .app {
  .chart_marimekko_story {
    margin: 0;
  }
}
